import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { useEffect } from "react";

import { routeMap } from "components/_App/Routes/routes";

const useLanguageRedirect = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const decodedPath = decodeURIComponent(location.pathname);
    const lang = i18n.language;

    const isArabic = lang === "ar";
    const isArabicPath = decodedPath.startsWith("/ar/");
    const mapped = routeMap[decodedPath];

    if (isArabic && !isArabicPath && mapped) {
      navigate(mapped, { replace: true });
    }

    if (!isArabic && isArabicPath && mapped) {
      navigate(mapped, { replace: true });
    }
  }, [i18n.language]);
};

export default useLanguageRedirect;
